import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=71f72187&scoped=true&lang=pug&"
import script from "./CouponList.vue?vue&type=script&lang=ts&"
export * from "./CouponList.vue?vue&type=script&lang=ts&"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=71f72187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f72187",
  null
  
)

export default component.exports